/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Friends_TitleInputs */

const en_friends_title = /** @type {(inputs: Friends_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Friends`)
};

const de_friends_title = /** @type {(inputs: Friends_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freunde`)
};

/**
* | output |
* | --- |
* | "Friends" |
*
* @param {Friends_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const friends_title = /** @type {((inputs?: Friends_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Friends_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_friends_title(inputs)
	return en_friends_title(inputs)
});